import React, { PropsWithChildren } from "react";

import { Expander } from "./expander";

interface ExpandableItemProps extends PropsWithChildren {
  label: string;
  expanded: boolean;
  onExpand: VoidFunction;
}

export const ExpandableItem = ({ label, expanded, onExpand, children }: ExpandableItemProps): JSX.Element => (
  <>
    <Expander label={label} expanded={expanded} onExpand={onExpand} />
    {expanded && children}
  </>
);
